"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Caption2Strong", {
    enumerable: true,
    get: function() {
        return Caption2Strong;
    }
});
const _createPreset = require("../createPreset");
const _useCaption2StrongStylesstyles = require("./useCaption2StrongStyles.styles");
const Caption2Strong = (0, _createPreset.createPreset)({
    useStyles: _useCaption2StrongStylesstyles.useCaption2StrongStyles,
    className: _useCaption2StrongStylesstyles.caption2StrongClassNames.root,
    displayName: 'Caption2Strong'
});
